import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { ADMIN_API_URL, AdminApiService } from './admin-api.service';

/**
 * Adds the admin bearer token to admin API requests only
 */
export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(ADMIN_API_URL)) {
    return next(req);
  }

  const session = inject(AdminApiService).session;
  if (!session) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${session.token}` } }));
};
